"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EditTaskName = void 0;
var _react = require("react");
var _Input = require("../../../../../UI/Input");
var _TaskManager = require("../../../TaskManager.provider");
var _SectionLabel = require("../SectionLabel");
var _EditTaskName = _interopRequireDefault(require("./EditTaskName.styles"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var EditTaskName = function EditTaskName() {
  var _useContext = (0, _react.useContext)(_TaskManager.TaskManagerContext),
    task = _useContext.task,
    editTaskDataName = _useContext.editTaskDataName,
    setEditTaskDataName = _useContext.setEditTaskDataName,
    setIsEditTaskDataChanged = _useContext.setIsEditTaskDataChanged,
    getLabel = _useContext.getLabel,
    isEditTaskDataOpened = _useContext.isEditTaskDataOpened;
  var styles = (0, _EditTaskName.default)();
  var handleNameChange = function handleNameChange(value) {
    if (!(task !== null && task !== void 0 && task.isReadOnly)) {
      setEditTaskDataName(value);
      setIsEditTaskDataChanged(true);
    }
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: styles['cc-TaskManager__edit-task-name'],
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_SectionLabel.SectionLabel, {
      text: getLabel('edit_task_name_title'),
      isDisabled: task === null || task === void 0 ? void 0 : task.isReadOnly
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Input.Input, {
      type: "text",
      view: "none",
      value: editTaskDataName,
      isDisabled: (task === null || task === void 0 ? void 0 : task.isReadOnly) || !isEditTaskDataOpened,
      onChange: handleNameChange,
      borderRadius: {
        borderRadius: 10
      }
    })]
  });
};
exports.EditTaskName = EditTaskName;